import {
  getConnectQuestions,
  type ConnectQuestionCategory,
} from "@components/OnboardingWizard/quizStepsConfig";
import type { Question } from "@components/Sender/QuestionItem";

export interface ConnectSlot {
  /** 英文原句（埋点 `question`） */
  prompt: string;
  /** 当前 locale 译文（展示与发送） */
  label: string;
  category: ConnectQuestionCategory;
}

export interface ResolveConnectSlotInput {
  /** 起步清单派生；undefined = 还没返回 */
  hasAccountData: boolean | undefined;
  /** 本设备今天是否点过槽位题 */
  clickedToday: boolean;
  /** goals 查询是否已结束（成功或失败） */
  goalsSettled: boolean;
  goalType: string | undefined;
  /** 今日已曝光次数，决定轮到组内哪一题 */
  rotationIndex: number;
}

/**
 * Chat 推荐问题第 1 张「要数据槽」（EDG-591 US1，fe-spec §3.3）。
 * 任一条件不满足返回 null —— 推荐区保持原样。
 * 广告会话不插槽由插入位置保证（只插在推荐接口那一档，见 resolveChatQuestions）。
 */
export function resolveConnectSlot(
  input: ResolveConnectSlotInput,
): ConnectSlot | null {
  if (
    input.hasAccountData !== false ||
    input.clickedToday ||
    !input.goalsSettled
  ) {
    return null;
  }
  // 没有 onboarding goal（含 goals 取数失败）→ 不填槽，第一张按既有规则（PRD 附录 A.1）
  const group = getConnectQuestions(input.goalType);
  if (!group) {
    return null;
  }
  const question =
    group.questions[Math.abs(input.rotationIndex) % group.questions.length];
  return {
    prompt: question.prompt,
    label: question.label(),
    category: group.category,
  };
}

/** 槽位题 → 推荐问题项：展示与发送都用当前 locale 译文，埋点信息挂在 connectSlot 上 */
export const connectSlotToQuestion = (slot: ConnectSlot): Question => ({
  id: `connect-slot-${slot.prompt}`,
  question: slot.label,
  connectSlot: { prompt: slot.prompt, category: slot.category },
});

/** 把槽位题放到第 1 张，总数不变 */
export const withConnectSlot = (
  questions: Question[] | undefined,
  slot: ConnectSlot | null,
  count: number,
): Question[] | undefined => {
  if (!slot) {
    return questions?.slice(0, count);
  }
  return [
    connectSlotToQuestion(slot),
    ...(questions ?? []).slice(0, count - 1),
  ];
};
